export const environment = {
  production: true,
  apiUrl: 'https://cs.luxgen.com.tw/api/', //PRD
  webUrl: 'https://cs.luxgen.com.tw/', //PRD
  downloadUrl: 'https://cs.luxgen.com.tw', //PRD
  urlLength: 4, // 因HTTP與HTTPS會取不同長度, 所以特別設定
  baseUrl: '/survey/'
};
